import { createStoreWithProducer } from '@xstate/store';
import { produce } from 'immer';

export type FailedOperation = {
  operationName: string;
  params: unknown;
};

export type RecordingErrorStoreContext = {
  hasError: boolean;
  lastError: string | null;
  failedOperation: FailedOperation | null;
};

const defaultContext: RecordingErrorStoreContext = {
  hasError: false,
  lastError: null,
  failedOperation: null,
};

export const recordingErrorStore = createStoreWithProducer(
  produce,
  defaultContext,
  {
    setRecordingError: (
      context,
      event: { error: string; operation?: FailedOperation },
    ) => {
      context.hasError = true;
      context.lastError = event.error;
      context.failedOperation = event.operation ?? null;
    },
    clearRecordingError: (context) => {
      context.hasError = false;
      context.lastError = null;
      context.failedOperation = null;
    },
  },
);
